module.exports = __webpack_public_path__ + "media/images/gallery/constellations/corona_australis/cra_lines-fcfd15e5a18e3d05c4ffe95d2f726322.gif";